import { useRef, useEffect } from 'react';

export const usePrevValue = (value:any) => {

  const ref = useRef(value);
  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
};
